export const ONBOARDING_INDEX = '0'
export const MAX_COLUMNS_NUMBER = 3
